import MuiTooltip from "@mui/material/Tooltip";
import { SxProps, Theme } from "@mui/material/styles";
import React from "react";
import { TypographyBodyMedium } from "../Typography/Typography";

export const clampTextSx = (lines: number) =>
  lines > 1
    ? ({
        display: "-webkit-box",
        WebkitLineClamp: lines,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        overflowWrap: "anywhere",
      } as const)
    : ({
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      } as const);

export const isElementClamped = (element: HTMLElement | null) =>
  !!element &&
  (element.scrollWidth > element.offsetWidth ||
    element.scrollHeight > element.offsetHeight);

type Props = {
  text: string;
  lines?: number;
  component?: React.ElementType;
  placement?: "top" | "bottom" | "left" | "right";
  sx?: SxProps<Theme>;
  dataQa?: string;
};

export const ClampedText = ({
  text,
  lines = 1,
  component: Component = TypographyBodyMedium,
  placement = "top",
  sx,
  dataQa,
}: Props) => {
  const [isClamped, setIsClamped] = React.useState(false);
  const textRef = React.useRef<HTMLElement>(null);

  return (
    <MuiTooltip
      title={isClamped ? text : ""}
      placement={placement}>
      <Component
        ref={textRef}
        data-qa={dataQa}
        onMouseEnter={() => setIsClamped(isElementClamped(textRef.current))}
        sx={{ ...clampTextSx(lines), ...sx }}>
        {text}
      </Component>
    </MuiTooltip>
  );
};

export default ClampedText;
